import { render, staticRenderFns } from "./mouldAssembling.vue?vue&type=template&id=518b87b4&"
import script from "./mouldAssembling.vue?vue&type=script&lang=js&"
export * from "./mouldAssembling.vue?vue&type=script&lang=js&"
import style0 from "./mouldAssembling.vue?vue&type=style&index=0&id=518b87b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports